export const ConfirmAlertArgument = {
  title: "Are you sure to remove the item?",
  showCancelButton: true,
  confirmButtonColor: "rgba(75, 181, 67, 0.72)",
  cancelButtonColor: "rgba(178, 38, 38, 0.72)",
  confirmButtonText: "YES",
  cancelButtonText: "NO",
};
